import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, createVNode as _createVNode, toDisplayString as _toDisplayString, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "steps__step-form" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("h3", { class: "h4 h4--b" }, " List all known designers, developers, and partners ", -1 /* HOISTED */)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("p", { class: "mb-24" }, [
  /*#__PURE__*/_createTextVNode(" All fields listed below are "),
  /*#__PURE__*/_createElementVNode("b", null, "optional"),
  /*#__PURE__*/_createTextVNode(". ")
], -1 /* HOISTED */)
const _hoisted_4 = ["onSubmit"]
const _hoisted_5 = /*#__PURE__*/_createElementVNode("legend", { class: "h5 h5--b" }, " Design team & developer ", -1 /* HOISTED */)
const _hoisted_6 = /*#__PURE__*/_createElementVNode("legend", { class: "h5 h5--b" }, " Partners ", -1 /* HOISTED */)
const _hoisted_7 = {
  class: "button button--fill",
  type: "submit"
}

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _hoisted_3,
    _createElementVNode("form", {
      class: "form form--fixed-fields",
      onSubmit: _withModifiers($setup.updateForm, ["prevent"])
    }, [
      _createElementVNode("fieldset", null, [
        _hoisted_5,
        _createVNode($setup["InputComponent"], {
          value: $setup.form_fields.architect,
          type: "checkboxes-dropdown",
          "input-id": "architect",
          name: "architect",
          label: "Architect",
          placeholder: "Search",
          options: $setup.filtered_architects,
          "selection-label": $setup.selected_architects_label,
          "filter-key": "architect",
          "filter-search": $setup.form_fields.architect.search_query,
          "active-values": $setup.form_fields.architect.values,
          required: false,
          errors: $setup.form_errors.architect || null,
          "onUpdate:value": _cache[0] || (_cache[0] = ( value ) => $setup.handleCheckboxDropdownUpdate( value, 'architect' ))
        }, null, 8 /* PROPS */, ["value", "options", "selection-label", "filter-search", "active-values", "errors"]),
        _createVNode($setup["NewCompanyFormComponent"], {
          "field-handle": "architect",
          "form-title": "Architect",
          "onRefresh:companies": _cache[1] || (_cache[1] = ( value, handle ) => $setup.updateCompanies( value, handle ))
        }),
        _createVNode($setup["InputComponent"], {
          value: $setup.form_fields.landscape_architect,
          type: "checkboxes-dropdown",
          "input-id": "landscape-architect",
          name: "landscape-architect",
          label: "Landscape Architect",
          placeholder: "Search",
          options: $setup.filtered_landscape_architects,
          "selection-label": $setup.selected_landscape_architects_label,
          "filter-key": "landscape_architect",
          "filter-search": $setup.form_fields.landscape_architect.search_query,
          "active-values": $setup.form_fields.landscape_architect.values,
          required: false,
          errors: $setup.form_errors.landscape_architect || null,
          "onUpdate:value": _cache[2] || (_cache[2] = ( value ) => $setup.handleCheckboxDropdownUpdate( value, 'landscape_architect' ))
        }, null, 8 /* PROPS */, ["value", "options", "selection-label", "filter-search", "active-values", "errors"]),
        _createVNode($setup["NewCompanyFormComponent"], {
          "field-handle": "landscape_architect",
          "form-title": "Landscape Architect",
          "onRefresh:companies": _cache[3] || (_cache[3] = ( value, handle ) => $setup.updateCompanies( value, handle ))
        }),
        _createVNode($setup["InputComponent"], {
          value: $setup.form_fields.interior_design,
          type: "checkboxes-dropdown",
          "input-id": "interior-designer",
          name: "interior-designer",
          label: "Interior Designer",
          placeholder: "Search",
          options: $setup.filtered_interior_designers,
          "selection-label": $setup.selected_interior_designers_label,
          "filter-key": "interior_design",
          "filter-search": $setup.form_fields.interior_design.search_query,
          "active-values": $setup.form_fields.interior_design.values,
          required: false,
          errors: $setup.form_errors.interior_design || null,
          "onUpdate:value": _cache[4] || (_cache[4] = ( value ) => $setup.handleCheckboxDropdownUpdate( value, 'interior_design' ))
        }, null, 8 /* PROPS */, ["value", "options", "selection-label", "filter-search", "active-values", "errors"]),
        _createVNode($setup["NewCompanyFormComponent"], {
          "field-handle": "interior_design",
          "form-title": "Interior Designer",
          "onRefresh:companies": _cache[5] || (_cache[5] = ( value, handle ) => $setup.updateCompanies( value, handle ))
        }),
        _createVNode($setup["InputComponent"], {
          value: $setup.form_fields.developer,
          type: "checkboxes-dropdown",
          "input-id": "developer",
          name: "developer",
          label: "Developer",
          placeholder: "Search",
          options: $setup.filtered_developers,
          "selection-label": $setup.selected_developers_label,
          "filter-key": "developer",
          "filter-search": $setup.form_fields.developer.search_query,
          "active-values": $setup.form_fields.developer.values,
          required: false,
          errors: $setup.form_errors.developer || null,
          "onUpdate:value": _cache[6] || (_cache[6] = ( value ) => $setup.handleCheckboxDropdownUpdate( value, 'developer' ))
        }, null, 8 /* PROPS */, ["value", "options", "selection-label", "filter-search", "active-values", "errors"]),
        _createVNode($setup["NewCompanyFormComponent"], {
          "field-handle": "developer",
          "form-title": "Developer",
          "onRefresh:companies": _cache[7] || (_cache[7] = ( value, handle ) => $setup.updateCompanies( value, handle ))
        })
      ]),
      _createElementVNode("fieldset", null, [
        _hoisted_6,
        _createVNode($setup["InputComponent"], {
          value: $setup.form_fields.creative_agency,
          type: "checkboxes-dropdown",
          "input-id": "creative-agency",
          name: "creative-agency",
          label: "Creative Agency",
          placeholder: "Search",
          options: $setup.filtered_creative_agencies,
          "selection-label": $setup.selected_creative_agencies_label,
          "filter-key": "creative_agency",
          "filter-search": $setup.form_fields.creative_agency.search_query,
          "active-values": $setup.form_fields.creative_agency.values,
          required: false,
          errors: $setup.form_errors.creative_agency || null,
          "onUpdate:value": _cache[8] || (_cache[8] = ( value ) => $setup.handleCheckboxDropdownUpdate( value, 'creative_agency' ))
        }, null, 8 /* PROPS */, ["value", "options", "selection-label", "filter-search", "active-values", "errors"]),
        _createVNode($setup["NewCompanyFormComponent"], {
          "field-handle": "creative_agency",
          "form-title": "Creative Agency",
          "onRefresh:companies": _cache[9] || (_cache[9] = ( value, handle ) => $setup.updateCompanies( value, handle ))
        }),
        _createVNode($setup["InputComponent"], {
          value: $setup.form_fields.brand_partner,
          type: "checkboxes-dropdown",
          "input-id": "brand-partner",
          name: "brand-partner",
          label: "Brand Partner",
          placeholder: "Search",
          options: $setup.filtered_brand_partners,
          "selection-label": $setup.selected_brand_partners_label,
          "filter-key": "brand_partner",
          "filter-search": $setup.form_fields.brand_partner.search_query,
          "active-values": $setup.form_fields.brand_partner.values,
          required: false,
          errors: $setup.form_errors.brand_partner || null,
          "onUpdate:value": _cache[10] || (_cache[10] = ( value ) => $setup.handleCheckboxDropdownUpdate( value, 'brand_partner' ))
        }, null, 8 /* PROPS */, ["value", "options", "selection-label", "filter-search", "active-values", "errors"]),
        _createVNode($setup["NewCompanyFormComponent"], {
          "field-handle": "brand_partner",
          "form-title": "Brand Partner",
          "onRefresh:companies": _cache[11] || (_cache[11] = ( value, handle ) => $setup.updateCompanies( value, handle ))
        }),
        _createVNode($setup["InputComponent"], {
          value: $setup.form_fields.sales_marketing,
          type: "checkboxes-dropdown",
          "input-id": "sales-marketing",
          name: "sales-marketing",
          label: "Sales & Marketing Partner",
          placeholder: "Search",
          options: $setup.filtered_sales_marketing,
          "selection-label": $setup.selected_sales_marketing_label,
          "filter-key": "sales_marketing",
          "filter-search": $setup.form_fields.sales_marketing.search_query,
          "active-values": $setup.form_fields.sales_marketing.values,
          required: false,
          errors: $setup.form_errors.sales_marketing || null,
          "onUpdate:value": _cache[12] || (_cache[12] = ( value ) => $setup.handleCheckboxDropdownUpdate( value, 'sales_marketing' ))
        }, null, 8 /* PROPS */, ["value", "options", "selection-label", "filter-search", "active-values", "errors"]),
        _createVNode($setup["NewCompanyFormComponent"], {
          "field-handle": "sales_marketing",
          "form-title": "Sales & Marketing Partner",
          "onRefresh:companies": _cache[13] || (_cache[13] = ( value, handle ) => $setup.updateCompanies( value, handle ))
        }),
        _createVNode($setup["InputComponent"], {
          value: $setup.form_fields.hospitality_operator,
          type: "checkboxes-dropdown",
          "input-id": "hospitality-operator",
          name: "hospitality-operator",
          label: "Hospitality Operator",
          placeholder: "Search",
          options: $setup.filtered_hospitality_operators,
          "selection-label": $setup.selected_hospitality_operators_label,
          "filter-key": "hospitality_operator",
          "filter-search": $setup.form_fields.hospitality_operator.search_query,
          "active-values": $setup.form_fields.hospitality_operator.values,
          required: false,
          errors: $setup.form_errors.hospitality_operator || null,
          "onUpdate:value": _cache[14] || (_cache[14] = ( value ) => $setup.handleCheckboxDropdownUpdate( value, 'hospitality_operator' ))
        }, null, 8 /* PROPS */, ["value", "options", "selection-label", "filter-search", "active-values", "errors"]),
        _createVNode($setup["NewCompanyFormComponent"], {
          "field-handle": "hospitality_operator",
          "form-title": "Hospitality Operator",
          "onRefresh:companies": _cache[15] || (_cache[15] = ( value, handle ) => $setup.updateCompanies( value, handle ))
        })
      ]),
      _createElementVNode("button", _hoisted_7, " Save " + _toDisplayString($props.stepTitle), 1 /* TEXT */)
    ], 40 /* PROPS, HYDRATE_EVENTS */, _hoisted_4)
  ]))
}